import React from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryCTA } from "@/components/revanche/PrimaryCTA";
import { MobileScreen } from "@/components/revanche/MobileScreen";

const Done = () => {
    const navigate = useNavigate();
    const answers = JSON.parse(localStorage.getItem("revanche_answers") || "{}");
    const prenom = (answers.prenom || "").trim();

    const footer = (
        <PrimaryCTA dataTestId="btn-done-continue" onClick={() => navigate("/")}>
            Continuer
        </PrimaryCTA>
    );

    return (
        <MobileScreen footer={footer} dataTestId="done-screen">
            <div className="flex-1 flex flex-col items-center justify-center text-center gap-4">
                <h2
                    className="font-display font-black uppercase text-white leading-[0.95] tracking-tight"
                    style={{ fontSize: "clamp(30px, 9vw, 42px)" }}
                >
                    {prenom ? `Merci ${prenom}.` : "Merci."}
                </h2>
                <p className="text-base text-white max-w-[300px]">
                    Ton profil est prêt. La suite arrive dans un instant.
                </p>
            </div>
        </MobileScreen>
    );
};

export default Done;
